import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react'
import ReactFlow, {
  Background,
  BackgroundVariant,
  ConnectionLineType,
  ControlButton,
  Controls,
  MiniMap,
  ReactFlowProvider,
  useEdgesState,
  useNodesState,
  useOnSelectionChange,
} from 'reactflow'
import 'reactflow/dist/base.css'
// import debounce from 'lodash/debounce';
import './global.less'
import styles from './App.less'
import loadingGif from './assets/image/loading.gif'
import { isDev } from './const'
import useStoreInContext from './hooks/useStoreInContext'
import { EDGE_TYPE } from './newComponents/edges'
import ConnectioinLine from './newComponents/edges/connectionLine'
import { ACTION_NODE, NODE_TYPE } from './newComponents/nodes'
import { CustomPanel } from './newComponents/panel/panel'
import { RULE_ERROR_CODE, TYPEIDS } from './utils/basic'
import { checkAll } from './utils/check'
import { getEdgeAndMarkerEndStyle, sortEdges } from './utils/edge'
import {
  IDControler,
  generateEdge,
  generateInitialNodesAndEdges,
  generateNodes,
  getNodePosition,
} from './utils/generate'
import { invokeAction } from './utils/invokeAction'
import { isValidData } from './utils/judge'
import {
  transformEdgeWhenNewNode,
  transformFlowDataToRawData,
  transformNodeWhenNewNode,
  transformRawDataToFlowData,
} from './utils/transform'
import type { CustomEdgeData, CustomEdgeType } from './newComponents/edges/customEdge'
import type { CustomNodeData, CustomNodeType } from './newComponents/nodes/types'
import type { NodeValidateType, RawData } from './types'
import type {
  Connection,
  EdgeChange,
  EdgeSelectionChange,
  NodeChange,
  NodeSelectionChange,
  ReactFlowInstance,
} from 'reactflow'

interface CusContextType {
  hasInputNode: boolean
  hasOutputNode: boolean
  handleAddNode: (
    type: keyof typeof NODE_TYPE,
    position?: { x: number, y: number },
  ) => void
}

export const CusContext = createContext<CusContextType>({} as CusContextType)

const { nodes: defaultNodes, edges: defaultEdges }
  = generateInitialNodesAndEdges()

function FlowComponent() {
  const {
    isLock,
    model,
    rawData,
    saveStatus,
    modifyName,
    nodeValidates,
    isInit,
    setSaveStatus,
    setModifyName,
    setIsLock,
  } = useStoreInContext(state => ({
    isLock: state.isLock,
    model: state.model,
    rawData: state.rawData,
    saveStatus: state.saveStatus,
    modifyName: state.modifyName,
    nodeValidates: state.nodeValidates,
    isInit: state.isInit,
    setSaveStatus: state.setSaveStatus,
    setModifyName: state.setModifyName,
    setIsLock: state.setIsLock,
  }))

  // const [dragKey, setDragKey] = useState<keyof typeof NODE_TYPE | null>(null);

  const edgeTypes = useMemo(() => EDGE_TYPE, [])
  const nodeTypes = useMemo(() => NODE_TYPE, [])

  const wrapperRef = useRef<HTMLDivElement>(null)

  const [nodes, setNodes, onNodesChange]
    = useNodesState<CustomNodeData>(defaultNodes)
  const [edges, setEdges, onEdgesChange]
    = useEdgesState<CustomEdgeData>(defaultEdges)

  const reactFlowInstanceRef = useRef<ReactFlowInstance<any, any>>()
  const isComponentInit = useRef(true)
  const isHidden = useRef(true)
  const isLockRef = useRef<boolean | null>(null)

  const num = useRef(1)

  const hasInputNode = !!nodes.find(n => n.type === 'input')
  const hasOutputNode = !!nodes.find(n => n.type === 'output')

  useOnSelectionChange({
    onChange: (selectAction) => {
      console.log('selectAction ===>', selectAction)
      const selectNodes = selectAction.nodes as CustomNodeType[]
      const selectEdges = selectAction.edges as CustomEdgeType[]

      if (selectNodes.length + selectEdges.length === 0) {
        // select背景
        setEdges(edges =>
          edges
            .map((edge) => {
              const hasErr = edge.data?.hasErr
              const { markerEnd, style } = getEdgeAndMarkerEndStyle(
                edge.markerEnd!,
                edge.style,
                hasErr,
                false,
              )
              edge.markerEnd = markerEnd
              edge.style = style

              return edge
            })
            .sort(sortEdges),
        )
        if (model) {
          const invokeData = {
            id: -1,
            typeName: 'flow',
          }
          // invokeAction(model, 'editFlow', invokeData);

          setTimeout(() => {
            invokeAction(model, 'editFlow', invokeData)
          }, 200)
        }
      }

      // if (selectNodes.length + selectEdges.length > 1) {
      //   // 多选 不处理
      //   selectEdges.forEach((edge) => {
      //     const hasErr = edge.data?.hasErr
      //     const { markerEnd, style } = getEdgeAndMarkerEndStyle(
      //       edge.markerEnd!,
      //       edge.style,
      //       hasErr,
      //       true,
      //     )
      //     edge.markerEnd = markerEnd
      //     edge.style = style
      //   })
      //   return
      // }

      // 其余情况视为单选
      // selectNodes.forEach((node) => {
      //   if (model) {
      //     resetNodeError(node.id)
      //     const invokeData = {
      //       id: Number(node.id),
      //       typeName: node.data.nodeType,
      //       type: TYPEIDS[node.data.nodeType],
      //       nodeName: node.data.nodeName,
      //     }
      //     setTimeout(() => {
      //       invokeAction(model, 'editNode', invokeData)
      //     }, 200)
      //   }
      // })
      // 重置选择线

      // setEdges((edges) =>
      //   edges
      //     .map((edge) => {
      //       const currEdge = selectEdges.find((n) => n.id === edge.id)
      //       const { markerEnd, style } = getEdgeAndMarkerEndStyle(
      //         edge.markerEnd!,
      //         edge.style,
      //         edge.data!.hasErr,
      //         !!currEdge?.selected,
      //       )
      //       edge.markerEnd = markerEnd
      //       edge.style = style
      //       return edge
      //     })
      //     .sort(sortEdges),
      // )

      // selectEdges.sort(sortEdges).forEach((edge) => {
      //   // const hasErr = edge.data?.hasErr;
      //   // const { markerEnd, style } = getEdgeAndMarkerEndStyle(edge.markerEnd!, edge.style, hasErr, true);
      //   // console.log('selectEdge ====>', markerEnd);
      //   // edge.markerEnd = markerEnd;
      //   // edge.style = style;
      //   if (model) {
      //     resetEdgeError(edge.id)
      //     const invokeData = {
      //       id: Number(edge.id),
      //       typeName: edge.data!.edgeType,
      //       type: TYPEIDS[edge.data!.edgeType!],
      //       nodeName: edge.data!.edgeName,
      //     }
      //     setTimeout(() => {
      //       invokeAction(model, 'editNode', invokeData)
      //     }, 200)
      //   }
      // })

      // setEdges((edges) => {
      //   return edges.sort(sortEdges);
      // });
    },
  })

  const resetNodeError = (id: string) => {
    setNodes(nodes =>
      nodes.map((node) => {
        if (node.id === id) {
          const newErrorInfo = node.data.errInfo.filter(
            info => info.code === RULE_ERROR_CODE.OTHER.code,
          )
          node.data = {
            ...node.data,
            hasErr: newErrorInfo.length > 0,
            errInfo: newErrorInfo,
          }
        }
        return node
      }),
    )
  }

  const resetEdgeError = (id: string) => {
    setEdges(edges =>
      edges
        .map((edge) => {
          if (edge.id === id) {
            const newErrorInfo = edge.data!.errInfo.filter(
              info => info.code === RULE_ERROR_CODE.OTHER.code,
            )
            const hasErr = newErrorInfo.length > 0
            const selected = edge.selected
            const { markerEnd, style } = getEdgeAndMarkerEndStyle(
              edge.markerEnd!,
              edge.style,
              hasErr,
              selected,
            )
            edge.markerEnd = markerEnd
            edge.style = style
            edge.data = {
              ...edge.data!,
              hasErr,
              errInfo: newErrorInfo,
            }
          }

          return edge
        })
        .sort(sortEdges),
    )
  }

  const handleNodesChange = (changes: NodeChange[]) => {
    // if (isLock) {
    //   changes = changes.filter((n) => n.type !== 'remove');
    // }
    // changes.length && onNodesChange(changes);
    // console.log('handleNodesChange ===>', changes)

    onNodesChange(changes)

    const selectedNode = changes.filter(
      (n: NodeSelectionChange) => n.type === 'select' && n.selected,
    )[0] as NodeSelectionChange
    if (selectedNode) {
      const currNode = nodes.find(n => n.id === selectedNode.id)!
      if (model) {
        resetNodeError(currNode.id)
        const invokeData = {
          id: Number(currNode.id),
          typeName: currNode.data.nodeType,
          type: TYPEIDS[currNode.data.nodeType],
          nodeName: currNode.data.nodeName,
        }
        setTimeout(() => {
          invokeAction(model, 'editNode', invokeData)
        }, 200)
      }
    }
  }

  const handleEdgesChange = (changes: EdgeChange[]) => {
    // if (isLock) {
    //   changes = changes.filter((n) => n.type !== 'remove');
    // }
    // changes.length && onEdgesChange(changes);
    // console.log('handleEdgesChange ===>', changes)

    onEdgesChange(changes)

    const selectedEdge = changes.filter(
      (n: EdgeSelectionChange) => n.type === 'select' && n.selected,
    )[0] as EdgeSelectionChange
    if (selectedEdge) {
      const currEdge = edges.find(n => n.id === selectedEdge.id)!
      if (model) {
        resetEdgeError(currEdge.id)
        const invokeData = {
          id: Number(currEdge.id),
          typeName: currEdge.data!.edgeType,
          type: TYPEIDS[currEdge.data!.edgeType!],
          nodeName: currEdge.data!.edgeName,
        }
        setTimeout(() => {
          invokeAction(model, 'editNode', invokeData)
        }, 200)
      }
    }
  }

  const getNodeName = (nodes: CustomNodeType[], nodeName: string): string => {
    const name = `${nodeName}_${num.current++}`
    const sameNameNode = nodes.find(n => n.data.nodeName === name)
    if (sameNameNode) {
      return getNodeName(nodes, nodeName)
    }
    return name
  }

  // const resetSelection = () => {
  //   setNodes(nodes => nodes.map(n => ({ ...n, selected: false })))
  //   setEdges(edges => edges.map(e => ({ ...e, selected: false })))
  // }

  const resetErrCode = () => {
    setNodes(nodes =>
      nodes.map((node) => {
        node.data = {
          ...node.data,
          hasErr: false,
          errInfo: [],
        }
        return node
      }),
    )
    setEdges(edges =>
      edges
        .map((edge) => {
          const selected = edge.selected
          const { markerEnd, style } = getEdgeAndMarkerEndStyle(
            edge.markerEnd!,
            edge.style,
            false,
            selected,
          )
          edge.markerEnd = markerEnd
          edge.style = style
          edge.data = {
            ...edge.data!,
            hasErr: false,
            errInfo: [],
          }
          return edge
        })
        .sort(sortEdges),
    )
  }

  // const resetEdgeOtherError = (id: string) => {
  //   setEdges((edges) =>
  //     edges
  //       .map((edge) => {
  //         if (edge.id === id) {
  //           const newErrorInfo = edge.data!.errInfo.filter((info) => info.code !== RULE_ERROR_CODE.OTHER.code);
  //           const hasErr = newErrorInfo.length > 0;
  //           const selected = edge.selected;
  //           const { markerEnd, style } = getEdgeAndMarkerEndStyle(edge.markerEnd!, edge.style, hasErr, selected);
  //           edge.markerEnd = markerEnd;
  //           edge.style = style;
  //           edge.data = {
  //             ...edge.data!,
  //             hasErr,
  //             errInfo: newErrorInfo,
  //           };
  //         }

  //         return edge;
  //       })
  //       .sort(sortEdges),
  //   );
  // };

  // const resetNodeOtherError = (id: string) => {
  //   setNodes((nodes) =>
  //     nodes.map((node) => {
  //       if (node.id === id) {
  //         const newErrorInfo = node.data.errInfo.filter((info) => info.code !== RULE_ERROR_CODE.OTHER.code);
  //         node.data = {
  //           ...node.data,
  //           hasErr: newErrorInfo.length > 0,
  //           errInfo: newErrorInfo,
  //         };
  //       }
  //       return node;
  //     }),
  //   );
  // };

  useEffect(() => {
    if (saveStatus) {
      resetErrCode()
      // TODO check 保存条件 --done
      const checkStatus = checkAll(nodes, edges)
      if (!checkStatus.hasErr) {
        // 允许保存
        const rawData: RawData = transformFlowDataToRawData(nodes, edges)
        // console.log(rawData);
        if (model) {
          // resetSelection();
          invokeAction(model, 'saveFlow', rawData)
        }
      }
      else {
        if (model) {
          invokeAction(model, 'saveFlow', {
            errorCodes: Array.from(
              new Set(checkStatus.errIdList.map(n => n.errInfo.code)),
            ),
          })
        }

        // const newEdges = edges;
        // const newNodes = nodes;
        setNodes(nodes =>
          nodes.map((node) => {
            const err = checkStatus.errIdList.find(
              err => err.id === node.id && err.type === 'node',
            )
            if (err) {
              node.data = {
                ...node.data,
                hasErr: true,
                errInfo: node.data.errInfo.concat(err.errInfo),
              }
            }
            return node
          }),
        )
        setEdges(edges =>
          edges
            .map((edge) => {
              const err = checkStatus.errIdList.find(
                err => err.id === edge.id && err.type === 'edge',
              )
              if (err) {
                const edgeData = edge.data
                if (edgeData) {
                  const { markerEnd, style } = getEdgeAndMarkerEndStyle(
                    edge.markerEnd!,
                    edge.style,
                    true,
                    edge.selected,
                  )
                  edge.markerEnd = markerEnd
                  edge.style = style
                  edge.data = {
                    ...edgeData,
                    hasErr: true,
                    errInfo: edgeData.errInfo.concat(err.errInfo),
                  }
                }
              }
              return edge
            })
            .sort(sortEdges),
        )
      }

      setSaveStatus(false)
    }
  }, [saveStatus])

  useEffect(() => {
    if (rawData) {
      const { nodes: _nodes, edges: _edges } = transformRawDataToFlowData(
        rawData,
        isLock,
      )
      setNodes(_nodes)
      setEdges(_edges)
      // TODO: 还是有问题
      // HACK:这里hack处理，在更新节点（异步获取）时，如果不进行 fitView，流程图的位置不对，如果不用 setTimeout，reactFlow fitView 是旧的(错的)
      setTimeout(() => {
        reactFlowInstanceRef.current?.fitView()
      }, 100)
      isLockRef.current = isLock
    }
  }, [rawData])

  useEffect(() => {
    if (isLock !== isLockRef.current) {
      if (isLock) {
        setNodes((prev) => {
          console.log('node ===>', prev)
          return prev.map(n => ({ ...n, deletable: false }))
        })
        setEdges((prev) => {
          return prev.map(n => ({ ...n, deletable: false }))
        })
      }
      else {
        setNodes((prev) => {
          return prev.map((n) => {
            if (n.type === 'input' || n.type === 'output') {
              return n
            }
            else {
              return { ...n, deletable: true }
            }
          })
        })
        setEdges((prev) => {
          return prev.map(n => ({ ...n, deletable: true }))
        })
      }

      isLockRef.current = isLock
    }
  }, [isLock])

  useEffect(() => {
    if (modifyName && isValidData(modifyName.nodeId)) {
      if (nodes.find(node => node.id === String(modifyName.nodeId))) {
        const newNodes = nodes.map((node) => {
          if (node.id !== String(modifyName.nodeId)) {
            return node
          }
          else {
            return {
              ...node,
              data: {
                ...node.data,
                nodeName: modifyName.nodeName,
              },
            }
          }
        })
        setNodes(() => newNodes)
      }
      if (edges.find(edge => edge.id === String(modifyName.nodeId))) {
        const newEdges = edges.map((edge) => {
          const { markerEnd, style } = getEdgeAndMarkerEndStyle(
            edge.markerEnd!,
            edge.style,
            edge.data?.hasErr,
            edge.selected,
          )
          edge.markerEnd = markerEnd
          edge.style = style
          if (edge.id === String(modifyName.nodeId)) {
            return {
              ...edge,
              label: modifyName.nodeName,
              data: {
                ...edge.data!,
                edgeName: modifyName.nodeName,
              },
            }
          }
          else {
            return edge
          }
        })

        setEdges(() => newEdges.sort(sortEdges))
      }
      setModifyName()
    }
  }, [modifyName])

  useEffect(() => {
    if (nodeValidates && nodeValidates.length) {
      const nodesValidateInner: NodeValidateType[] = []
      const edgesValidateInner: NodeValidateType[] = []

      for (let i = 0; i < nodeValidates.length; i++) {
        const nodeValidate = nodeValidates[i]
        if (nodeValidate.nodeId !== -1) {
          if (nodes.find(node => node.id === String(nodeValidate.nodeId))) {
            nodesValidateInner.push(nodeValidate)
          }
          if (edges.find(edge => edge.id === String(nodeValidate.nodeId))) {
            edgesValidateInner.push(nodeValidate)
          }
        }
      }

      if (
        nodesValidateInner.length

      ) {
        setNodes((nodes) => {
          const nodesCache = [...nodes]
          nodesValidateInner.forEach((nodeValidate) => {
            const index = nodesCache.findIndex(
              n => String(nodeValidate.nodeId) === n.id,
            )
            if (index > -1) {
              const _node = nodesCache[index]
              if (nodeValidate.status === 'error') {
                _node.data = {
                  ..._node.data,
                  hasErr: true,
                  errInfo: _node.data.errInfo
                    .filter(info => info.code !== RULE_ERROR_CODE.OTHER.code)
                    .concat({
                      code: RULE_ERROR_CODE.OTHER.code,
                      msg: nodeValidate.validMessage,
                    }),
                }
              }
              else if (nodeValidate.status === 'pass') {
                _node.data = {
                  ..._node.data,
                  hasErr: false,
                  errInfo: [],
                }
              }
            }
          })

          return nodesCache
        })
      }

      if (edgesValidateInner.length) {
        setEdges((edges) => {
          const edgesCache = [...edges]
          edgesValidateInner.forEach((edgeValidate) => {
            const index = edgesCache.findIndex(
              n => String(edgeValidate.nodeId) === n.id,
            )

            if (index > -1) {
              const _edge = edgesCache[index]
              if (edgeValidate.status === 'error') {
                const { markerEnd, style } = getEdgeAndMarkerEndStyle(
                  _edge.markerEnd!,
                  _edge.style,
                  true,
                  _edge.selected,
                )
                _edge.markerEnd = markerEnd
                _edge.style = style
                _edge.data = {
                  ..._edge.data!,
                  hasErr: true,
                  errInfo: _edge
                    .data!.errInfo.filter(
                    info => info.code !== RULE_ERROR_CODE.OTHER.code,
                  )
                    .concat({
                      code: RULE_ERROR_CODE.OTHER.code,
                      msg: edgeValidate.validMessage,
                    }),
                }
              }
              else if (edgeValidate.status === 'pass') {
                const hasErr = false
                const selected = _edge.selected
                const { markerEnd, style } = getEdgeAndMarkerEndStyle(
                  _edge.markerEnd!,
                  _edge.style,
                  hasErr,
                  selected,
                )
                _edge.markerEnd = markerEnd
                _edge.style = style
                _edge.data = {
                  ..._edge.data!,
                  hasErr,
                  errInfo: [],
                }
              }
            }
          })

          return edgesCache.sort(sortEdges)
        })
      }
    }
  }, [nodeValidates])

  const onConnect = (connection: Connection) => {
    if (isLock)
      return
    // 已存在
    const isAlreadyExists = edges.some(
      edge =>
        edge.source === connection.source && edge.target === connection.target,
    )
    // 自我形成环结构
    const isSurroundingOneself = connection.source === connection.target
    // 双节点间最小环结构
    const isToNodesRing = edges.some(
      edge =>
        edge.source === connection.target && edge.target === connection.source,
    )
    if (!isAlreadyExists && !isSurroundingOneself && !isToNodesRing) {
      const newEdge = generateEdge(
        String(IDControler.getId()),
        '',
        connection.source!,
        connection.target!,
        connection.sourceHandle,
        connection.targetHandle,
      )

      // 通知后端新增节点
      if (model) {
        const transfer = transformEdgeWhenNewNode(
          newEdge,
          nodes,
          edges.concat(newEdge),
        )
        const invokeData = {
          id: Number(newEdge.id),
          type: TYPEIDS[newEdge.data!.edgeType],
          nodes: [],
          transfers: [transfer],
        }
        invokeAction(model, 'newNode', invokeData)
      }
      setEdges(edges => edges.concat(newEdge).sort(sortEdges))
    }
    else {
      // TODO ： 走统一报错
      // model.invokeAync()通知后台使用系统悬浮报错或警告 或 自己实现顶部浮窗报错
    }
  }

  const handleAddNode = useCallback(
    (type: keyof typeof NODE_TYPE, position?: { x: number, y: number }) => {
      const newNode = generateNodes[type](String(IDControler.getId()))
      if (ACTION_NODE.includes(type)) {
        // newNode.data.nodeName += `_${num++}`;
        newNode.data.nodeName = getNodeName(nodes, newNode.data.nodeName)
      }

      if (position) {
        newNode.position = reactFlowInstanceRef.current!.screenToFlowPosition({
          x: position.x,
          y: position.y,
        })
      }
      else {
        const inputNode = nodes.find(n => n.type === 'input')

        let position = { x: 0, y: 0 }
        if (type !== 'input') {
          position = getNodePosition(
            nodes,
            { x: inputNode ? inputNode.position.x : 0 },
            { y: 80 },
          )
        }
        newNode.positionAbsolute = { x: 0, y: 0 }
        newNode.position = position
      }

      if (model) {
        const rawData = transformNodeWhenNewNode(
          newNode,
          nodes.concat(newNode),
          edges,
        )
        const invokeData = {
          id: Number(newNode.id),
          type: TYPEIDS[newNode.data.nodeType],
          nodes: [rawData],
          transfers: [],
        }
        invokeAction(model, 'newNode', invokeData)
      }

      setNodes(nds => nds.concat(newNode))
    },
    [nodes, edges],
  )

  const onDragOver = useCallback((event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
  }, [])

  const onDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()

    const type = event.dataTransfer.getData(
      'application/reactflow',
    ) as keyof typeof NODE_TYPE
    console.log('onDrop ===>', type)

    // check if the dropped element is valid
    if (typeof type === 'undefined' || !type) {
      return
    }

    handleAddNode(type, { x: event.clientX, y: event.clientY })
  }

  const handleNodesDelete = (nodes: CustomNodeType[]) => {
    if (isLock)
      return
    if (model) {
      const invokeData = {
        nodeIds: nodes.map(node => Number(node.id)),
        transferIds: [],
      }
      invokeAction(model, 'delNode', invokeData)
    }
  }

  const handleEdgesDelete = (edges: CustomEdgeType[]) => {
    if (isLock)
      return
    if (model) {
      const invokeData = {
        nodeIds: [],
        transferIds: edges.map(edge => Number(edge.id)),
      }
      invokeAction(model, 'delNode', invokeData)
    }
  }

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const target = entry.target as HTMLElement
        const width = target.offsetWidth
        const height = target.offsetHeight

        if (width === 0 && height === 0) {
          // console.log('元素被隐藏了');
          isHidden.current = true
        }
        else {
          // console.log('isHidden ===>', isHidden);
          if (isHidden.current) {
            // console.log('元素展示了');
            isHidden.current = false
          }
          else {
            // console.log('元素大小改变了');
            isHidden.current = false
            if (!isComponentInit.current) {
              if (reactFlowInstanceRef.current) {
                // console.log('resizeObserver handle');
                reactFlowInstanceRef.current.fitView()
              }
            }
          }
        }
      }
    })

    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current)
    }

    isComponentInit.current = false

    return () => {
      if (wrapperRef.current) {
        resizeObserver.unobserve(wrapperRef.current)
      }
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <div className={`${styles.gaiFlow}`}>
      <CusContext.Provider
        value={{ hasInputNode, hasOutputNode, handleAddNode }}
      >
        <div className={`${styles.mainFlow}`} ref={wrapperRef}>
          {isInit
            ? (
                <div className={styles.loading}>
                  <img className={styles.loadingImg} src={loadingGif} />
                </div>
              )
            : null}
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={handleNodesChange}
            onEdgesChange={handleEdgesChange}
            onConnect={onConnect}
            onNodesDelete={handleNodesDelete}
            onEdgesDelete={handleEdgesDelete}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            // onDragEnd={handleDrop}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onInit={(instance) => {
              reactFlowInstanceRef.current = instance
            }}
            className={`${styles.flowContent} ${
              isInit ? styles.flowContent : ''
            }`}
            connectionLineComponent={ConnectioinLine}
            connectionLineType={ConnectionLineType.Bezier}
            // zoom配置
            minZoom={0.5}
            maxZoom={2.0}
            // 禁用双击放大
            zoomOnDoubleClick={false}
            // 禁用节点拖拽
            nodesDraggable={true}
            // 拖拽时选择
            selectionOnDrag={true}
            // 禁用拖拽时选中节点 开启后切换节点触发两次 useOnSelectionChange
            // selectNodesOnDrag={false}
            panOnDrag={true}
            panOnScroll={false}
            // 删除
            // deleteKeyCode={null}
            // 多选
            // multiSelectionKeyCode={null}
            // 划选
            // selectionKeyCode={null}
            // 异步生成的节点直接设置 fitView 可能导致位置不对
            // fitView
            edgesUpdatable={!isLock}
            // edgesFocusable={!isLock}
            nodesConnectable={!isLock}
            // nodesFocusable={!isLock}
            // draggable={!isLock}
            // elementsSelectable={!isLock}
          >
            <Background
              id="flowBackground"
              gap={20}
              size={2}
              color="#ECEDF3"
              style={{
                backgroundColor: '#E2E7EF',
              }}
              variant={BackgroundVariant.Dots}
            />

            {
              isDev
                ? (
                    <>
                      <MiniMap
                        pannable
                        draggable
                        zoomable
                        nodeColor="transparent"
                        nodeStrokeColor={(node) => {
                          switch (node.type) {
                            case 'inputNode':
                              return 'green'
                            case 'outputNode':
                              return 'blue'
                            case 'conditioin':
                              return 'purple'
                            case 'taskNode':
                              return 'orange'
                            default:
                              return 'orange'
                          }
                        }}
                        nodeBorderRadius={10}
                      />
                      {' '}
                      <Controls>
                        <>
                          <ControlButton
                            onClick={() => invokeAction(model!, 'saveFlow', {})}
                          >
                            {/* <MagicWandIcon /> */}
                            save
                          </ControlButton>
                          <ControlButton
                            onClick={() =>
                              model?.invokeAsync(
                                'getModifyName',
                                nodes[Math.floor(Math.random() * nodes.length)].id,
                              )}
                          >
                            changeName
                          </ControlButton>
                          <ControlButton
                            onClick={() =>
                              model?.invokeAsync(
                                'getNodeValidate',
                                nodes[Math.floor(Math.random() * nodes.length)].id,
                              )}
                          >
                            getError
                          </ControlButton>
                          <ControlButton
                            onClick={() =>
                              model?.invokeAsync(
                                'resetNodeValidate',
                                nodes[Math.floor(Math.random() * nodes.length)].id,
                              )}
                          >
                            resetError
                          </ControlButton>
                          {/* <ControlButton onClick={() => dispatch(changeShowId(!showId))}>
                      <RocketIcon />
                      ShowId
                    </ControlButton> */}
                          <ControlButton onClick={() => setIsLock(!isLock)}>
                            {/* <RocketIcon /> */}
                            {isLock ? 'unLock' : 'lock'}
                          </ControlButton>
                        </>
                      </Controls>
                    </>
                  )
                : null
            }
            {/* <Panel position={'top-left'} children={<NodePanel />} /> */}
          </ReactFlow>
        </div>
        <CustomPanel />
      </CusContext.Provider>
    </div>
  )
}

function ReactFlowProviderFlow() {
  return (
    <ReactFlowProvider>
      <FlowComponent />
    </ReactFlowProvider>
  )
}

export default ReactFlowProviderFlow
